import { render } from "./Button-text.vue?vue&type=template&id=10402622&scoped=true"
import script from "./Button-text.vue?vue&type=script&lang=js"
export * from "./Button-text.vue?vue&type=script&lang=js"

import "./Button-text.vue?vue&type=style&index=0&id=10402622&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10402622"]])

export default __exports__